import { api } from "@/lib/api";

// Mesmo cache do AppShell (sessionStorage "oplyx_feat_v1", 5 min): o menu e as
// telas leem a mesma resposta de /features/me.
const KEY = "oplyx_feat_v1";
const TTL = 5 * 60 * 1000;
let inflight = null;

async function loadFeatures() {
  try {
    const cached = JSON.parse(sessionStorage.getItem(KEY) || "null");
    if (cached && Date.now() - cached.ts < TTL) return cached.data;
  } catch (_) {}
  if (!inflight) {
    inflight = api.get("/features/me")
      .then(r => {
        try { sessionStorage.setItem(KEY, JSON.stringify({ data: r.data, ts: Date.now() })); } catch (_) {}
        return r.data;
      })
      .finally(() => { inflight = null; });
  }
  return inflight;
}

/**
 * O recurso está ligado para o tenant? Tela que chama rota protegida por
 * `require_feature` pergunta antes: o 403 de recurso abre o popup "Recurso
 * bloqueado" para quem nem pediu aquele recurso. Sem resposta (rede, erro),
 * devolve true para não esconder nada por engano.
 */
export async function featureEnabled(name) {
  try {
    const meta = await loadFeatures();
    return meta?.features?.[name] !== false;
  } catch (_) {
    return true;
  }
}
